import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import ViewClientUser from './ViewClientUser';

const ClientUserHome = () => {

    return (
        <Box sx={{ width: '100%' }}>
            <ViewClientUser />
        </Box>
    );
}

export default ClientUserHome;